import _ from 'underscore'
import {createSelector} from 'reselect'
import {selectUserPanel} from '../selector'
import {getAllUsers, getFullUserInfo, getUserTeamAssignmentsData} from '../userData/selectors'
import {areRatesEqual} from './utils'
import {areUnorderedArraysEqual} from '../../../atUtils'

export const selectCreateUserPanel = createSelector(
    selectUserPanel,
    (userPanel) => userPanel.createPanel
)

export const isShown = state => selectCreateUserPanel(state).show

export const isLoading = state => selectCreateUserPanel(state).loading

export const getSelectedTab = state => selectCreateUserPanel(state).selectedTab

export const isUserCreated = state => selectCreateUserPanel(state).userCreated

export const isSaving = state => selectCreateUserPanel(state).saving

export const isInvitationSent = state => selectCreateUserPanel(state).invitationSent

export const isShowFutureInvitation = state => selectCreateUserPanel(state).showFutureInvitation

export const getManageAssignments = state => selectCreateUserPanel(state).manageAssignments

export const getManageAssignmentsTasks = state => selectCreateUserPanel(state).tasksMap

export const getCopyUserId = state => selectCreateUserPanel(state).copyUserId

export const getCopyUser = createSelector(
    getCopyUserId,
    getAllUsers,
    (id, users) => {
        return id ? users.find(user => user.id === id) : null
    }
)

export const getManagementAssignmentsCptIds = createSelector(
    getManageAssignments,
    (ma) => ({
        customerIds: ma.addedCustomerIds,
        customerIdsExcludingSelf: ma.addedCustomerIdsExcludingSelf,
        projectIds: ma.addedProjectIds,
        projectIdsExcludingSelf: ma.addedProjectIdsExcludingSelf,
        taskIds: ma.addedTaskIds
    })
)

export const isLoaded = state => selectCreateUserPanel(state).loaded

export const isNeedToLoadData = createSelector(
    isShown,
    isLoaded,
    (show, loaded) => show === true && loaded === false
)

export const getApproversByGroupIds = state => selectCreateUserPanel(state).approversByGroupIds

const getDefaultUserInfo = state => selectCreateUserPanel(state).defaultUserInfo
const getDefaultTeamAssignments = state => selectCreateUserPanel(state).defaultTeamAssignments
const getDefaultManageAssignments = state => selectCreateUserPanel(state).defaultManageAssignments

const isFullUserInfoChanged = createSelector(
    getFullUserInfo,
    getDefaultUserInfo,
    (userInfo, defaultUserInfo) => {
        return userInfo.firstName !== defaultUserInfo.firstName ||
               userInfo.lastName !== defaultUserInfo.lastName ||
               userInfo.middleInitial !== defaultUserInfo.middleInitial ||
               userInfo.username !== defaultUserInfo.username ||
               userInfo.email !== defaultUserInfo.email ||
               userInfo.password !== defaultUserInfo.password ||
               userInfo.retypedPassword !== defaultUserInfo.retypedPassword ||
               userInfo.userGroupId !== defaultUserInfo.userGroupId ||
               userInfo.timeZoneGroupId !== defaultUserInfo.timeZoneGroupId ||
               userInfo.hireDate !== defaultUserInfo.hireDate ||
               userInfo.enabled !== defaultUserInfo.enabled ||
               userInfo.enabledInOtherProduct !== defaultUserInfo.enabledInOtherProduct ||
               userInfo.overtimeLevel !== defaultUserInfo.overtimeLevel ||
               userInfo.requiresTTApproval !== defaultUserInfo.requiresTTApproval ||
               userInfo.defaultInitialSchedule !== defaultUserInfo.defaultInitialSchedule ||
               !_.isEqual(userInfo.initialSchedule, defaultUserInfo.initialSchedule) ||
               !areRatesEqual(userInfo.rates, defaultUserInfo.rates) ||
               !areUnorderedArraysEqual(userInfo.accessRights, defaultUserInfo.accessRights)
    }
)

const isTeamAssignmentsChanged = createSelector(
    getUserTeamAssignmentsData,
    getDefaultTeamAssignments,
    (teamAssignments, defaultTeamAssignments) => {
        return teamAssignments.teamAssignmentType !== defaultTeamAssignments.teamAssignmentType ||
               teamAssignments.assignedUsersCount !== defaultTeamAssignments.assignedUsersCount ||
               !areUnorderedArraysEqual(teamAssignments.assignedGroups, defaultTeamAssignments.assignedGroups) ||
               !areUnorderedArraysEqual(teamAssignments.assignedUsers, defaultTeamAssignments.assignedUsers)
    }
)

const isManageAssignmentsChanged = createSelector(
    getManageAssignments,
    getDefaultManageAssignments,
    (manageAssignments, defaultManageAssignments) => {
        return manageAssignments.managementAssignmentsSelection !== defaultManageAssignments.managementAssignmentsSelection ||
               !areUnorderedArraysEqual(manageAssignments.addedTaskIds, defaultManageAssignments.addedTaskIds) ||
               !areUnorderedArraysEqual(manageAssignments.addedProjectIds, defaultManageAssignments.addedProjectIds) ||
               !areUnorderedArraysEqual(manageAssignments.addedCustomerIds, defaultManageAssignments.addedCustomerIds)
    }
)

export const isUserDataChanged = createSelector(
    isFullUserInfoChanged,
    isTeamAssignmentsChanged,
    isManageAssignmentsChanged,
    (fullUserInfoChanged, teamAssignmentsChanged, manageAssignmentsChanged) => {
        return fullUserInfoChanged || teamAssignmentsChanged || manageAssignmentsChanged
    }
)

export const getUserPanelPasswordValidationRequested = state => selectCreateUserPanel(state).passwordValidationRequired


// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/selectors.js